<template>
  <div class="teacher-list-wrapper">
    <van-nav-bar
      class="nav"
      fixed
      placeholder
      :title="organization.name"
    />
    <div class="wrapper">
      <basis-list-wrapper
        target-key="teachers"
      >
        <template v-slot:item="{item}">
          <teacher-item :key="item.name" :item="item" />
        </template>
      </basis-list-wrapper>
    </div>
    <div v-if="organization.creditAwards.initial" class="popup-wrapper">
      <div :class="['credits-wrapper', {initial}]">
        首次登录，可领取 <span>{{ organization.creditAwards.initial }}</span> 积分奖励
        <van-button class="button" @click="receiveCreditHandler">点击领取</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BasisListWrapper } from '@/components/basis'
import { TeacherItem } from '@/components/item'
import { mapGetters, mapActions } from 'vuex'
import { mixinWxShare } from '@/mixins'

export default {
  name: 'TeacherListWrapper',
  components: { BasisListWrapper, TeacherItem },
  mixins: [mixinWxShare],
  data: () => ({
  }),
  computed: {
    ...mapGetters(['organization', 'credits']),
    initial () {
      const { drawedToday, nextType } = this.credits
      return !drawedToday && nextType === 'initial'
    }
  },
  methods: {
    ...mapActions(['updateCredits']),
    receiveCreditHandler () {
      this.updateCredits()
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-list-wrapper {
  .nav {
    ::v-deep {
      .van-nav-bar__title {
        @include sc($font-size-xlg, $color-text-heavy);
      }
    }
  }
  .wrapper {
    padding: 19px 16px;
    .title {
      @include sc($font-size-xl, $color-text-heavy);
      @include lw(28px, 500);
      text-align: center;
    }
    .basis-list-wrapper {
      padding: 18px 0;
      .teacher-item {
        @include bg-image-png('/teacher/list-bg');
        border-radius: 50px 8px 8px 50px;
        background-color: #fff;
        & + .teacher-item {
          margin-top: 16px;
        }
      }
    }
  }
  .popup-wrapper {
    .credits-wrapper {
      @include bottomfix(-100%);
      @include wh(343px, initial);
      padding: 8px 16px;
      line-height: 25px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #fff;
      border-radius:4px;
      box-shadow:0px 5px 6px 4px rgba(0,0,0,0.05),0px 2px 4px 0px rgba(2,20,33,0.08);
      transition: all 1s ease-out;
      &.initial {
        @include bottomfix(66px);
        @include wh(343px, initial);
      }
      .button {
        @include plain-button(69px, 25px);
        @include ft($font-size-base, inherit);
        float: right;
        border-radius: 12px;
      }
    }
  }
}
</style>
